import store from '@/store'

export default [
  {
    path: '/admin/dealer-users',
    name: 'dealer-user',
    meta: { requiresAuth: true },
    component: () => import('@/pages/administrator/dealer-user')
  }
]
